import React from "react";
import { getItem } from "constants/localstorage";
import "./button.scss";

const Button = React.forwardRef((props, ref) => {
  const {
    icon,
    title,
    className,
    type,
    tabIndex,
    disabled,
    autoFocus,
    ...rest
  } = props;

  return (
    <button
      autoFocus={getItem("add") === "add" && autoFocus}
      type={type}
      disabled={disabled}
      className={`btn btn--md ${className}`}
      ref={ref}
      {...rest}
      tabIndex={tabIndex || null}
    >
      {icon} {title}
    </button>
  );
});

export default Button;
